<div class="flex items-center gap-2">
  <app-button (onChangeClick)="create()">
    <span class="flex items-center gap-1.5">
      <app-icon class="!h-4 !w-4 !text-[16px] !leading-4">add</app-icon>
      {{ 'crm_tasks.card.create' | translate }}
    </span>
  </app-button>
</div>

<div class="mt-3 flex flex-col gap-1.5">
  @if (loading) {
    <div class="flex min-h-24 items-center justify-center">
      <app-loader />
    </div>
  } @else if (failed) {
    <div class="flex min-h-24 flex-col items-center justify-center gap-2 rounded-lg bg-slate-50 text-sm text-slate-500">
      {{ 'crm_tasks.card.load_failed' | translate }}
      <app-button btnType="stroked" (onChangeClick)="load()">{{ 'crm_tasks.form.retry' | translate }}</app-button>
    </div>
  } @else {
    @for (task of tasks; track task.id) {
      <button
        type="button"
        class="flex w-full min-w-0 items-center gap-3 !rounded-lg px-3 py-2 text-left transition"
        [ngClass]="task.is_overdue ? 'bg-rose-50 hover:bg-rose-100' : 'bg-slate-50 hover:bg-slate-100'"
        (click)="open(task)"
      >
        <span class="min-w-0 flex-1">
          <span
            class="block truncate text-sm font-semibold text-slate-900"
            [class.line-through]="isTaskFinished(task)"
            [title]="task.title"
          >
            {{ task.title }}
          </span>
          <span class="mt-1 flex min-w-0 flex-wrap items-center gap-x-3 gap-y-1 text-xs text-slate-500">
            <app-task-user class="max-w-48" size="18px" [user]="getUser(task.assignee_id)" />
            @if (task.deadline) {
              <span
                class="inline-flex items-center gap-1"
                [ngClass]="task.is_overdue ? 'font-semibold text-rose-600' : ''"
              >
                <app-icon class="!h-3.5 !w-3.5 !text-[14px] !leading-none">{{
                  task.is_overdue ? 'alarm' : 'event'
                }}</app-icon>
                {{ task.deadline | date: 'dd.MM.yyyy HH:mm' }}
              </span>
            }
          </span>
        </span>
        <app-task-status-badge [status]="task.status" />
      </button>
    } @empty {
      <div class="flex min-h-24 items-center justify-center rounded-lg bg-slate-50 text-sm text-slate-400">
        {{ 'crm_tasks.card.empty' | translate }}
      </div>
    }
  }
</div>
